import { $$ } from '../../helpers/shortcuts';
import { Component } from 'preact';
import { media } from '../../helpers/media-queries';
import { html } from '../../helpers/preact-html';

import {
  disableScrolling,
  enableScrolling,
} from '../../helpers/disable-scrolling';

import { MobileNavigation } from './MobileNavigation.component';
import { DesktopNavigation } from './DesktopNavigation.component';

class NavigationWrapper extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      mediaDesktop: null,
      currentMenuLayer: 1,
      menuKeyCounter: 1,
    };

    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onMenuLayerChange = this.onMenuLayerChange.bind(this);

    // for development/debugging:
    // this.open();
  }

  componentWillMount() {
    this.registerMediaQueries();
    this.registerTriggers();
  }

  componentWillUnmount() {
    document.removeEventListener('select-subnav-L1', this.open);
  }

  registerTriggers() {
    this.registerTriggerEvents({
      triggerNodes: $$('.trigger-navigation-toggle'),
      action: this.toggle,
    });

    this.registerTriggerEvents({
      triggerNodes: $$('.trigger-navigation-open'),
      action: this.open,
    });

    this.registerTriggerEvents({
      triggerNodes: $$('.trigger-navigation-close'),
      action: this.close,
    });
  }

  registerMediaQueries() {
    media('large', ({ matches }) => {
      this.setState({ mediaDesktop: matches });
    });
  }

  registerTriggerEvents({ triggerNodes, action }) {
    triggerNodes.forEach((triggerNode) => {
      triggerNode.onclick = () => {
        action();
      };
    });

    document.addEventListener('select-subnav-L1', this.open);
  }

  toggle() {
    this.state.isOpen ? this.close() : this.open();
  }

  open() {
    this.setState({ isOpen: true });
    disableScrolling();
    setTimeout(window.updateInert, 1);
  }

  close() {
    this.setState({
      isOpen: false,
    });
    // delay counter to delay resizing
    setTimeout(
      () => this.setState({ menuKeyCounter: this.state.menuKeyCounter + 1 }),
      300,
    );

    enableScrolling();
    setTimeout(window.updateInert, 1);
  }

  onMenuLayerChange({ newMenuLayer }) {
    this.setState({ currentMenuLayer: newMenuLayer });
  }

  render(
    { navTree, logo },
    { isOpen, mediaDesktop, currentMenuLayer, menuKeyCounter },
  ) {
    const backgroundClasses = ['navigation-background'];
    const wrapperClasses = ['navigation-wrapper'];
    if (!isOpen) {
      backgroundClasses.push('navigation-isclosed');
      wrapperClasses.push('navigation-isclosed');
    }

    let navigationComponent = null;
    if (mediaDesktop !== null) {
      navigationComponent = mediaDesktop ? DesktopNavigation : MobileNavigation;
      if (mediaDesktop) {
        switch (currentMenuLayer) {
          case 2:
            wrapperClasses.push('navigation-wrapper-reducedwidth');
            break;
          case 3:
            wrapperClasses.push('navigation-wrapper-extendedwidth');
            break;
        }
      }
    }

    !mediaDesktop && isOpen && window.scrollTo({ left: 0, top: 0 }); //force top position so that logo is in the right position

    return html`
      <div
        class=${backgroundClasses.join(' ')}
        onClick=${this.toggle}
        ></div>
      <div class=${wrapperClasses.join(' ')}>
        <${navigationComponent}
          key=${mediaDesktop ? `nav-desktop-${menuKeyCounter}` : 'nav-mobile'}
          navTree=${navTree}
          logo=${logo}
          onCloseButtonClick=${this.close}
          onMenuLayerChange=${this.onMenuLayerChange}>
        </${navigationComponent}>
      </div>
    `;
  }
}

export { NavigationWrapper };
